module.exports = __webpack_public_path__ + "media/images/apple-icon-60x60-76698f4b.png";